import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export interface ToastNotification {
  message: string;
  isError: boolean;
}

const DEFAULT_DURATION_MS = 3000;

// App-wide toast channel — mounted once in AppComponent so it survives route
// navigations (e.g. the redirect to /login that always follows a logout).
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly notification$ = new BehaviorSubject<ToastNotification | null>(null);
  readonly notifications: Observable<ToastNotification | null> = this.notification$.asObservable();

  private dismissTimer: ReturnType<typeof setTimeout> | undefined;

  constructor(private readonly translate: TranslateService) {}

  show(messageKey: string, isError = false, durationMs = DEFAULT_DURATION_MS): void {
    clearTimeout(this.dismissTimer);
    this.notification$.next({ message: this.translate.instant(messageKey), isError });
    this.dismissTimer = setTimeout(() => this.notification$.next(null), durationMs);
  }

  showError(messageKey: string, durationMs = DEFAULT_DURATION_MS): void {
    this.show(messageKey, true, durationMs);
  }
}
